import { Button, Checkbox, Comment, Divider, Form, message, Radio, Select, Space, Spin, Tooltip, Typography } from "antd";
import { CloseCircleOutlined, MessageOutlined } from "@ant-design/icons";
import RichTextEditor from "../../Components/RichTextEditor";
import QnAQuestion from "../../Collections/Video/Q&A/QnAQuestion";
import { useState } from 'react';
import { connect } from 'react-redux';

const TEST = [{"id":18,"text":{"blocks":[{"key":"1uu4s","data":{},"text":"test question","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"coupon":5,"collection":5,"module":null,"video":null,"collectionName":"Computer Science: An Interdisciplinary Approach","moduleName":null,"videoName":null,"createdAt":"2021-08-27T13:14:28.603654-05:00","responses":[{"id":288,"text":{"blocks":[{"key":"gojs","data":{},"text":"a","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"createdAt":"2021-09-15T18:05:21.473265-05:00","question":18,"instructorHighlight":true,"anonymous":false},{"id":567,"text":{"blocks":[{"key":"86dnv","data":{},"text":"a","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"createdAt":"2021-09-23T15:10:44.327880-05:00","question":18,"instructorHighlight":true,"anonymous":false},{"id":651,"text":{"blocks":[{"key":"83d2f","data":{},"text":"test","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"user":{"id":2,"username":"jon.hong@rutgers.edu","firstName":"Jonathan","lastName":"Hong"},"createdAt":"2021-09-27T09:44:59.093133-05:00","question":18,"instructorHighlight":false,"anonymous":false},{"id":652,"text":{"blocks":[{"key":"763v2","data":{},"text":"anonymous test","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"user":{"id":2,"username":"jon.hong@rutgers.edu","firstName":"Jonathan","lastName":"Hong"},"createdAt":"2021-09-27T09:45:06.590303-05:00","question":18,"instructorHighlight":false,"anonymous":true}],"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"anonymous":false,"removed":false},{"id":20,"text":{"blocks":[{"key":"1uu4s","data":{},"text":"test question","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"coupon":5,"collection":5,"module":null,"video":null,"collectionName":"Computer Science: An Interdisciplinary Approach","moduleName":null,"videoName":null,"createdAt":"2021-08-27T13:14:34.994407-05:00","responses":[],"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"anonymous":false,"removed":false},{"id":21,"text":{"blocks":[{"key":"1uu4s","data":{},"text":"t","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"coupon":5,"collection":5,"module":null,"video":null,"collectionName":"Computer Science: An Interdisciplinary Approach","moduleName":null,"videoName":null,"createdAt":"2021-08-27T13:15:01.125453-05:00","responses":[],"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"anonymous":false,"removed":false},{"id":22,"text":{"blocks":[{"key":"1uu4s","data":{},"text":"t","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"coupon":5,"collection":5,"module":null,"video":null,"collectionName":"Computer Science: An Interdisciplinary Approach","moduleName":null,"videoName":null,"createdAt":"2021-08-27T13:15:04.346358-05:00","responses":[],"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"anonymous":false,"removed":false},{"id":23,"text":{"blocks":[{"key":"fvjsj","data":{},"text":"test","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"coupon":5,"collection":5,"module":null,"video":null,"collectionName":"Computer Science: An Interdisciplinary Approach","moduleName":null,"videoName":null,"createdAt":"2021-08-27T13:22:14.545939-05:00","responses":[],"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"anonymous":false,"removed":false},{"id":337,"text":{"blocks":[{"key":"c0kso","data":{},"text":"test","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"coupon":5,"collection":5,"module":null,"video":null,"collectionName":"Computer Science: An Interdisciplinary Approach","moduleName":null,"videoName":null,"createdAt":"2021-09-15T17:33:45.754719-05:00","responses":[{"id":284,"text":{"blocks":[{"key":"65gq8","data":{},"text":"test","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"user":{"id":2,"username":"jon.hong@rutgers.edu","firstName":"Jonathan","lastName":"Hong"},"createdAt":"2021-09-15T17:33:51.756201-05:00","question":337,"instructorHighlight":false,"anonymous":false},{"id":285,"text":{"blocks":[{"key":"65gq8","data":{},"text":"test","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"user":{"id":2,"username":"jon.hong@rutgers.edu","firstName":"Jonathan","lastName":"Hong"},"createdAt":"2021-09-15T17:33:57.796909-05:00","question":337,"instructorHighlight":false,"anonymous":true}],"user":{"id":2,"username":"jon.hong@rutgers.edu","firstName":"Jonathan","lastName":"Hong"},"anonymous":false,"removed":false},{"id":563,"text":{"blocks":[{"key":"5nf6b","data":{},"text":"a","type":"unstyled","depth":0,"entityRanges":[],"inlineStyleRanges":[]}],"entityMap":{}},"coupon":5,"collection":5,"module":null,"video":null,"collectionName":"Computer Science: An Interdisciplinary Approach","moduleName":null,"videoName":null,"createdAt":"2021-09-22T23:28:18.786664-05:00","responses":[],"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"anonymous":false,"removed":false},{"id":17,"text":"This question was removed.","coupon":5,"collection":5,"module":null,"video":null,"collectionName":"Computer Science: An Interdisciplinary Approach","moduleName":null,"videoName":null,"createdAt":"2021-08-27T13:14:27.755263-05:00","responses":[],"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"anonymous":false,"removed":true},{"id":19,"text":"This question was removed.","coupon":5,"collection":5,"module":null,"video":null,"collectionName":"Computer Science: An Interdisciplinary Approach","moduleName":null,"videoName":null,"createdAt":"2021-08-27T13:14:31.915365-05:00","responses":[],"user":{"id":1,"username":"admin","firstName":"Cubits","lastName":"Admin"},"anonymous":false,"removed":true}]
const { Option } = Select;
const { Title, Text } = Typography;

const options = [
    { label: 'Collection', value: 'collection' },
    { label: 'Module', value: 'module' },
    { label: 'Video', value: 'video' },
  ];


const QnAContainer = ({ collectionId, collectionQnA, collectionQnAStatus="LOADED", enrolledLicenses, fetchingEnrolledLicensesStatus, fetchCollectionQnA, fetchModuleQnA, fetchVideoQnA, moduleId, moduleQnA, moduleQnAStatus, postQnAQuestion, selectedQnALevel="collection", setSelectedQnALevel, videoQnA, videoQnAStatus, videoId}) => {
    const [reset, setReset] = useState(false);
    const [form] = Form.useForm();
    const [filteredLicenses, setFilteredLicenses] = useState([])
    const [licensesFiltered, setLicensesFiltered] = useState(false);
    const [selectedLicense, setSelectedLicense] = useState(false);
    const [fetchedQnA, setFetchedQnA] = useState(false);
    const [submitQuestionLoading, setSubmitQuestionLoading] = useState(false);
    const [prevVideoId, setPrevVideoId] = useState(null);
    const [isAnonymous, setIsAnonymous] = useState(false);


    if(prevVideoId != videoId){
        setPrevVideoId(videoId)
        setFilteredLicenses([])
        setSelectedLicense(false);
        setLicensesFiltered(false);
        setFetchedQnA(false);
    }
  
    let currentUser = { "username": "John Smith"}


    const handleOnRichTextEditorChange = (value) => {
        form.setFieldsValue({
            text: value
        })
    }

    const handleQnALevelChange = (event) => {
        setSelectedQnALevel(event.target.value)
    }

    const handleCheckboxChange = (event) => {
        form.setFieldsValue({
            anonymous: event.target.checked
        })
        setIsAnonymous(event.target.checked)
    }


    

    const renderQnAPostQuestionContent = () => {
        const renderPostingAsUsername = () => {
     
            if(isAnonymous){
                return "Anonymous User"
            }else {
                return currentUser.firstName && currentUser.lastName ? `${currentUser.firstName} ${currentUser.lastName}` : currentUser.username
            }   
        }
       
        return <>
            
              
                <br/>
                <Text type='secondary'>Posting as: {renderPostingAsUsername()}</Text>
                    <div style={{marginTop: "5px"}}>
                        <Form form={form} >
                            <Form.Item name='text' hidden>
                                
                            </Form.Item>
                            <Form.Item name='anonymous' hidden>
                                
                            </Form.Item>
                        </Form>
                        <RichTextEditor 
                            customOnChange={handleOnRichTextEditorChange} 
                            placeholder="Ask a question (Use @ to reference timestamp/range in a video. Ex: @1:00 to @2:00)" 
                            readOnly={false} 
                            reset={reset} 
                            setReset={setReset} 
                            allowTimestamps={true}
                        />
                    </div>
                    <br/>
                    <div style={{ display: "flex", justifyContent: "space-between"}}>
                        <Space></Space>
                        
                        <Tooltip title="Disabled for demonstration purposes">
                            <Button 
                            type="primary" 
                            disabled
                            onClick={() => {
                                let textValue = form.getFieldValue('text')
                                if(textValue && textValue.blocks.some(block => block.text.length)){
                                    setSubmitQuestionLoading(true);
                                    form.submit()
                                } else {
                                    message.warning('Please enter a question first.')
                                }
                            }} 
                            loading={submitQuestionLoading}
                        >
                            <MessageOutlined /> Ask Question
                        </Button>
                        </Tooltip>
                    </div>
                   
                <Divider style={{ margin: "15px 0 5px 0"}}/>
        </>
    }
  
    const renderInnerContent = () => {
        let qna, qnaStatus;
        switch(selectedQnALevel){
            case "collection":
                qna = collectionQnA;
                qnaStatus = collectionQnAStatus
                break;
            case "module":
                qna = moduleQnA;
                qnaStatus = moduleQnAStatus
                break;
            default:
                qna = videoQnA;
                qnaStatus = videoQnAStatus
                break;

        }
      
        if(true){
            return <>
                {renderQnAPostQuestionContent ()}
                
            </>
        } else {
            return <>
                {renderQnAPostQuestionContent()}
                No questions asked yet
            </>
        }
    }


    
    return  <div id='q-and-a-section'>
                <div id='q-n-a-header'>
                    <Space align="baseline" size="small">
                        <Title level={3} style={{display: "inline-block"}}>Q&A</Title>
                        <Text className="qna-sub-heading">Discussion for </Text>
                        SAMPLE COUPON
                    </Space>
                    <Space >
                        <div id='q-n-a-instructor-square'></div>
                        <Text className="instructor-color">Includes Instructor Response</Text>
                    </Space>
                </div>
                <Divider style={{ margin: "0 0 12px 0"}}/>

             
                { 
                    renderInnerContent()
                }
            </div>
}


export default QnAContainer;